import { logger } from 'src/lib/logger';

const REFRESH_TOKEN_KEY = 'refresh_token';

export const authStorage = {
  saveRefreshToken(token: string): void {
    try {
      localStorage.setItem(REFRESH_TOKEN_KEY, token);
    } catch (error) {
      logger.error('[AuthStorage] Failed to save refresh token:', error);
    }
  },

  loadRefreshToken(): string | null {
    try {
      return localStorage.getItem(REFRESH_TOKEN_KEY);
    } catch (error) {
      logger.error('[AuthStorage] Failed to load refresh token:', error);
      return null;
    }
  },

  clearRefreshToken(): void {
    try {
      localStorage.removeItem(REFRESH_TOKEN_KEY);
    } catch (error) {
      logger.error('[AuthStorage] Failed to clear refresh token:', error);
    }
  },
};
